import React from "react";
import {
  List,
  Datagrid,
  TextField,
  NumberField,
  DateField,
  ArrayField,
  ChipField,
  SingleFieldList,
  ShowButton,
  SimpleShowLayout,
  BooleanField
} from "react-admin";
import {DeviceFamilyField, DoctorReferenceField, PatientReferenceField} from "../../misc/customFields";
import { runningSessionExporter } from "../../misc/exports";
import { SessionFilterWithDeviceFamily } from "../../misc/filters";
import SessionShow from "./utils";
import withStyles from "@material-ui/core/styles/withStyles";
import DevicesAside from "./DevicesAside";

export const RunningSessionList = props => {
  return (
    <div>
      <List
        {...props}
        exporter={runningSessionExporter}
        filters={<SessionFilterWithDeviceFamily />}
        bulkActionButtons={null}
      >
        <Datagrid>
          <ShowButton />
          <TextField source="id" />
          <DoctorReferenceField sortBy="doctor__first_name" label="Clinician"/>
          <PatientReferenceField
              label="Patient"
              source="patientInfo.id"
              allowEmpty
              sortBy="patientInfo"
          />
          <DeviceFamilyField label="Device Family" />
          <TextField
            source="platformInfo.os"
            label="OS"
            sortBy="platformInfo__os"
          />
          <TextField
            source="platformInfo.phoneModel"
            label="Model"
            sortBy="platformInfo__phoneModel"
          />
          <TextField source="mode" sortable={false} />
          <BooleanField source="is_remote" sortable={false} label="Remote" />
          <NumberField
            source="deviceNumber"
            label="Devices Number"
            sortable={false}
          />
          <ArrayField source="devices" label="Serials">
            <SingleFieldList>
              <ChipField source="serialNumber" />
            </SingleFieldList>
          </ArrayField>
          <TextField source="programName" label="Program" sortable={false} />
          <TextField
            source="muscleGroupName"
            label="Muscle Group"
            sortable={false}
          />
          <TextField source="type" sortable={false} />
          <NumberField source="painScoreBefore" label="Pain Score Before" />
          <DateField source="startDate" showTime />
          <DateField
            source="expectedFinishDate"
            showTime
            label="End Date (expected)"
          />
        </Datagrid>
      </List>
    </div>
  );
};

const editStyles = {
  root: { alignItems: "flex-start" },
  inlineField3: {
    display: "inline-block",
    width: "33%"
  },
  inlineField: {
    display: "inline-block",
    width: "50%",
    whiteSpace: "nowrap"
  }
};

const RunningSessionShow_ = ({ classes, ...props }) => {
  return (
    <SessionShow {...props} aside={<DevicesAside />} showTitle="Session Info">
      <SimpleShowLayout>
        <TextField source="id" className={classes.inlineField} />
        <DoctorReferenceField className={classes.inlineField} label="Clinician" />
        <NumberField
          source="deviceNumber"
          label="Devices Number"
          className={classes.inlineField}
        />
        <PatientReferenceField
            label="Patient"
            source="patientInfo.id"
            allowEmpty
            className={classes.inlineField}
        />
        <TextField
          source="platformInfo.os"
          label="OS"
          className={classes.inlineField}
        />
        <TextField
          source="platformInfo.phoneModel"
          label="Model"
          className={classes.inlineField}
        />
        <TextField
            source="platformInfo.appVersion"
            label="App Version"
            className={classes.inlineField}
        />
        <TextField source="mode" className={classes.inlineField} />
        <TextField
          source="programType"
          label="Program Type"
          className={classes.inlineField}
        />
        <TextField
          source="programName"
          label="Program"
          className={classes.inlineField}
        />
        <TextField
          source="muscleGroupName"
          label="Muscle Group"
          className={classes.inlineField}
        />
        <TextField source="type" className={classes.inlineField} />
        <NumberField source="painScoreBefore" className={classes.inlineField} />
        <DateField
          source="startDate"
          showTime
          className={classes.inlineField}
        />
        <DateField
          source="expectedFinishDate"
          showTime
          label="End Date (expected)"
          className={classes.inlineField}
        />
      </SimpleShowLayout>
    </SessionShow>
  );
};

export const RunningSessionShow = withStyles(editStyles)(RunningSessionShow_);
